import styled from 'styled-components';

export const PricingStyled = styled.div``;
